import { Calculator, Calendar, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import Beregner from '../../components/Beregner';
import SEO from '../../components/SEO';

export default function BeregnerPageDe() {
  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Ersparnisrechner - Berechnen Sie Ihre Einsparung mit dem Danshaker"
        description="Nutzen Sie unseren interaktiven Ersparnisrechner und sehen Sie, wie viel Zeit und Geld Sie in Ihrem Pferdestall mit einer Danshaker Entmistungsmaschine einsparen können."
        path="/de/sparrechner"
        lang="de"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Main Content */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-24 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4 mb-16">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Calculator className="h-3.5 w-3.5" aria-hidden="true" />
            <span>Optimieren Sie Ihre Stallwirtschaft</span>
          </div>
          <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Ersparnisrechner
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed font-medium">
            Berechnen Sie anhand Ihrer eigenen Stallzahlen, wie viel Zeit, Einstreu und Geld Sie mit dem Danshaker sparen können.
          </p>
        </div>

        {/* The Calculator Component */}
        <Beregner lang="de" />

        {/* Additional Help / Callout Section */}
        <div className="mt-20 rounded-3xl bg-slate-900 p-8 md:p-12 text-white shadow-2xl flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="space-y-3 max-w-xl text-center md:text-left">
            <h2 className="text-2xl font-bold">Möchten Sie eine persönliche Wirtschaftlichkeitsberatung?</h2>
            <p className="text-slate-300 text-sm md:text-base font-medium">
              Rufen Sie uns an oder fordern Sie eine kostenlose Vorführung direkt in Ihrem Stall an. Wir beraten Sie gern persönlich.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 shrink-0">
            <a
              href="tel:25303589"
              className="flex items-center gap-2 rounded-xl bg-slate-800 px-6 py-3.5 text-sm font-bold text-white transition hover:bg-slate-700 border border-slate-700"
            >
              <Phone className="h-4 w-4 text-[#0E67A2]" />
              +45 2530 3589
            </a>
            <Link
              to="/de/kostenlose-demo"
              className="flex items-center gap-2 rounded-xl bg-[#0E67A2] px-6 py-3.5 text-sm font-bold text-white transition hover:bg-[#0E67A2]/90 shadow-md"
            >
              <Calendar className="h-4 w-4" />
              Kostenlose Demo anfordern
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
